exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".Key-2343011e{display:flex}.rows-d4a5c922{display:flex;flex-flow:row wrap;flex:2 0 85%;padding-right:15px}.rows-d4a5c922 .row-b53d4bd7{flex-basis:100%;display:flex;flex-flow:row nowrap;justify-content:space-between}.rows-d4a5c922 .row-b53d4bd7>*{flex:1 0 16%}.expandArrow-370d60a2,.expandArrowExpanded-37b94b8f{cursor:pointer}.expandArrow-370d60a2{margin:auto 0px;transform:rotate(0deg);transition:transform 200ms ease}.expandArrowExpanded-37b94b8f{transform:rotate(180deg)}\n", ""]);

// Exports
exports.locals = {
	"Key": "Key-2343011e",
	"rows": "rows-d4a5c922",
	"row": "row-b53d4bd7",
	"expandArrow": "expandArrow-370d60a2",
	"expandArrowExpanded": "expandArrowExpanded-37b94b8f"
};